import { NgModule } from '@angular/core'
import { EmailStatusFilterPipe } from './email-status-filter.pipe'
import { EmailTypeFilterPipe } from './email-type-filter.pipe';

import { BadgesTextColourPipe } from './badges-text-colour.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';

@NgModule({
    declarations: [EmailStatusFilterPipe, EmailTypeFilterPipe, BadgesTextColourPipe, SafeHtmlPipe],
    imports: [],
    exports: [EmailStatusFilterPipe, EmailTypeFilterPipe, BadgesTextColourPipe, SafeHtmlPipe],
})
export class PipesModule { }
